import { Children } from 'react';
import SectionHandler from './SectionHandler';
import { useSelector } from 'react-redux';
import {
    Heading,
    Accordion,
    AccordionButton,
    AccordionIcon,
    AccordionItem,
    AccordionPanel,
    Box,
    HStack,
    Icon,
} from '@chakra-ui/react';
import { classNames } from '@/utils/classNames';

const SubAccordionItemHandler = ({
    children,
    index,
    icon,
    label,
    errors,
    touched,
    values,
    setValues,
    accordionAdornment,
    isDisabled,
    isLastItem,
}) => {
    const childrenArray = Array.isArray(children)
        ? children
        : typeof children === 'function'
          ? [children({ errors, touched, values, setValues })]
          : [children];
    const childrenCount = Children.count(childrenArray);
    const { darkMode } = useSelector((state) => state.settings);
    return (
        <Accordion allowToggle>
            <AccordionItem
                key={index}
                isDisabled={isDisabled}
                borderTop="none"
                borderBottom={isLastItem ? 'none' : undefined}>
                {({ isExpanded }) => (
                    <>
                        <HStack spacing={0} position="relative">
                            <AccordionButton
                                flex="1"
                                paddingTop={1}
                                paddingBottom={1}>
                                <Box as="span" flex="1" textAlign="left">
                                    <HStack>
                                        {icon && (
                                            <Icon as={icon} fontSize="25px" />
                                        )}
                                        <Heading
                                            size="sm"
                                            className={classNames(
                                                darkMode
                                                    ? 'text-white'
                                                    : 'text-black',
                                            )}>
                                            {label}
                                        </Heading>
                                    </HStack>
                                </Box>
                                <Box as="span" flex="0" textAlign="right">
                                    <AccordionIcon />
                                </Box>
                            </AccordionButton>
                            {accordionAdornment && (
                                <Box
                                    position="absolute"
                                    right="35px"
                                    zIndex={2}
                                    onClick={(e) => e.stopPropagation()}>
                                    {accordionAdornment}
                                </Box>
                            )}
                        </HStack>
                        <AccordionPanel
                            pb={4}
                            mb={4}
                            sx={{
                                height: isExpanded ? 'auto' : 0,
                                overflow: 'hidden',
                            }}>
                            {Children.map(childrenArray, (child, index) => (
                                <SectionHandler
                                    key={`section-handler-${index}`}
                                    index={index}
                                    child={child}
                                    count={childrenCount}
                                />
                            ))}
                        </AccordionPanel>
                    </>
                )}
            </AccordionItem>
        </Accordion>
    );
};

export default SubAccordionItemHandler;
